import produce from 'immer';

import { SUPER_ADMIN_LOGIN_FAILURE, SUPER_ADMIN_LOGIN_SUCCESS } from '@actions/superAdmin';

const initialState: ISuperAdminStore = {
  superAdminToken: null,
  error: null,
};

export default (state: ISuperAdminStore = initialState, action: any) =>
  produce(state, (draftState: ISuperAdminStore) => {
    switch (action.type) {
      case SUPER_ADMIN_LOGIN_SUCCESS:
        draftState.superAdminToken = action.response.token;
        draftState.error = null;

        return;

      case SUPER_ADMIN_LOGIN_FAILURE:
        draftState.superAdminToken = null;
        draftState.error = action.error;

        return;
    }
  });
